import { Component } from '@angular/core';
import { PopupsManagerService } from '../../services/popups-manager.service';
import { BasePopupComponent } from '../../common/base/base-popup.component';

@Component({
  selector: 'app-how-to',
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.scss'],
})
export class HowToComponent extends BasePopupComponent {
  constructor(popupsManagerService: PopupsManagerService) {
    super(popupsManagerService);
  }
}
